import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/amit.jpeg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
  AiFillPhone
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  function Submit(e){
    e.preventDefault()
    document.getElementById('form_det').reset()
    window.alert('message sent')
  }
  function run(){
    console.log('phone is triggerd')
  }
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with programming and I have at least learnt
              something, I think… 🤷‍♂️
              <br />
              <br />I am fluent in classics like
              <i>
                <b className="purple">Javascript,html,css</b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies Products and learning new Technologies </b> 
                
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} id="circle_border" className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/MrAmit-itech"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/AmitYad49146849"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/amit-yadav-9b1761227/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/er.amit_cool/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  // href="#"
                  onClick={run}
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillPhone />
                </a>
              </li> */}
            </ul>
          </Col>
          {/* <Col md={12}>
            <div className="form">
              <form id="form_det" onSubmit={Submit}>
              <fieldset className="field">
              <legend className="head" >Contact</legend>
                  <table>
                    <tr>
                      <td className="head">Name:</td>
                      <td><input placeholder="name"></input></td>
                    </tr>
                    <tr>
                      <td className="head">Email:</td>
                      <td><input type="email" placeholder="email"></input></td>
                    </tr>
                    <tr>
                      <td className="head" >Message:</td>
                      <td><input id="msgbox" typeof="text" placeholder="message"></input></td>
                    </tr>
                    &nbsp
                    &nbsp
                    <tr>
                      <td className="head"><input type="submit"></input></td>
                    </tr>
                  </table>
              </fieldset>
              
            </form></div>
            
          </Col> */}
        </Row>
        
      </Container>
    </Container>
  );
}
export default Home2;
